/** 账号限制、官方应用提示、anti-ban（gbwhatpro.org） */
export const ACCOUNT_POSTS = {
	'why-is-gb-whatsapp-account-banned': {
		slug: 'why-is-gb-whatsapp-account-banned',
		categoryId: 'account-security',
		title: 'Why Is My GB WhatsApp Account Banned?',
		description:
			'A GB WhatsApp Pro account can be limited for an unofficial client, spam-like sends, or a timer you can wait out. Match the on-screen message before you reinstall.',
		keywords: 'gb whatsapp account banned, gb whatsapp temporary ban',
		h1: 'Why Is My GB WhatsApp Account Banned?',
		lead:
			'If GB WhatsApp Pro suddenly blocks sending or logs you out, read the sentence on the screen first. A countdown, a full logout, and a missing SMS code are three different problems.',
		body: `
      <h2>Why the limit showed up</h2>
      <p>The common cause is the client itself. GB WhatsApp Pro is not the official app, and WhatsApp can limit numbers that stay on unsupported builds. A second cause is how the number was used: lots of new chats, forwarded messages, or automated replies that look like spam.</p>
      <p>A weak signal or a delayed SMS is not a ban. If you never got a code and there is no timer, that is a registration problem, not this page.</p>

      <h2>Match the message you see</h2>
      <ol class="article-steps">
        <li><strong>Screenshot the banner.</strong> Include the timer, if any, and any support link. Do this before you force-close the app.</li>
        <li><strong>Check whether chats still open.</strong> A timer with read-only chats is usually temporary. A logout that demands the official app is stricter.</li>
        <li><strong>Stop new login attempts.</strong> Requesting code after code can add a longer wait on top of the original limit.</li>
      </ol>
      <p>When the banner says to continue only in the official app, follow <a href="/gb-whatsapp-says-use-official-whatsapp/">what to do when GB WhatsApp asks for the official app</a> instead of hunting another APK the same day.</p>

      <h2>What is safe to try</h2>
      <p>If a timer is counting down and you can still open Settings, leave the mod alone until it ends. Do not pay anyone who offers to “unban” the number. WhatsApp does not sell that service, and those pages often want your verification code.</p>
      <p>If you may have to uninstall, export or back up first. <a href="/installation/backup-chats/">Saving GB WhatsApp chats before you remove the app</a> only works while this build still opens. A backup made after you clear data is already too late.</p>

      <h2>If the timer ends and it happens again</h2>
      <p>Repeating the same mod login after a warning often shortens the next window. Temporary limits sometimes lift. A number that keeps returning to the same screen may not. No APK on this site can restore a number WhatsApp has already limited. If the same screen returns after the timer, staying on GB WhatsApp Pro repeats the warning. It does not clear it.</p>
    `,
		faqs: [
			[
				'Is a 24-hour timer a permanent ban?',
				'Usually not. Wait it out and avoid another unofficial login during the countdown.',
			],
			[
				'Can GBWhatPro.org appeal for me?',
				'No. This site publishes guides. Any appeal has to go through WhatsApp’s own help flow, when that flow is offered on your screen.',
			],
		],
		publishedAt: '2026-10-15',
		updatedAt: '2026-11-04',
		coverTheme: 'safe',
		coverLabel: 'Account Ban',
	},
	'gb-whatsapp-says-use-official-whatsapp': {
		slug: 'gb-whatsapp-says-use-official-whatsapp',
		categoryId: 'account-security',
		title: 'GB WhatsApp Says Use Official WhatsApp? What to Do',
		description:
			'GB WhatsApp Pro can show a warning that only official WhatsApp may continue. Here is how to protect the number and any chats you can still export.',
		keywords: 'gb whatsapp use official whatsapp, gb whatsapp warning',
		h1: 'GB WhatsApp Says Use Official WhatsApp? What to Do',
		lead:
			'That warning means WhatsApp rejected this client for your number. It is not a broken SMS by itself. Act while the app still opens, if it does.',
		body: `
      <h2>Read the whole warning</h2>
      <p>Some screens only say to install official WhatsApp. Others add a date or a countdown. A warning you can dismiss and still send messages is earlier than a logout that blocks the chat list.</p>
      <p>Write down the wording before you uninstall anything. A countdown you can still read is a temporary limit. A logout that will not show chats is a harder stop.</p>

      <h2>Do this while the app still opens</h2>
      <ol class="article-steps">
        <li><strong>Send one test to yourself or a close contact.</strong> If it stays on the clock icon, treat the account as already limited.</li>
        <li><strong>Export important chats.</strong> Use the in-app export if your build has it. Save photos from those threads to the gallery. A text export will not import later, but you keep the words.</li>
        <li><strong>Do not request a pile of new codes.</strong> Extra SMS attempts do not clear a client warning.</li>
      </ol>

      <h2>When you should switch</h2>
      <p>If this number is how you get bank codes or work messages, move it to official WhatsApp from the Play Store. <a href="/switch-from-gb-whatsapp-to-official-whatsapp/">Switching this number to official WhatsApp</a> often keeps the number and loses some GB-only chat history. Plan for that before you delete the mod.</p>
      <p>Do not install a random “fix” APK that claims to bypass the banner. Those files are a common way people pick up a tampered package on top of an already limited number.</p>

      <h2>When it is not this warning</h2>
      <p>If registration never finishes and you simply never receive a text, you are in a different problem. Use <a href="/gb-whatsapp-verification-code-not-received/">checks for a GB WhatsApp code that never arrives</a> instead of treating every login screen as a ban.</p>
    `,
		faqs: [
			[
				'Can I ignore the warning and keep chatting?',
				'You might for a while. The next step is often a longer limit or a logout. WhatsApp’s own text says to use the official app.',
			],
			[
				'Will my GB chats appear in official WhatsApp automatically?',
				'Do not count on it. Mod backups and official Google Drive backups are not the same file.',
			],
		],
		publishedAt: '2026-10-16',
		updatedAt: '2026-11-04',
		coverTheme: 'safe',
		coverLabel: 'Official App Warning',
	},
	'does-gb-whatsapp-anti-ban-work': {
		slug: 'does-gb-whatsapp-anti-ban-work',
		categoryId: 'account-security',
		title: 'Does GB WhatsApp Anti-Ban Work? Risks Explained',
		description:
			'Anti-ban in GB WhatsApp Pro is a label on a modified app, not a promise from WhatsApp. See what it can change and what it cannot undo.',
		keywords: 'gb whatsapp anti ban, gb whatsapp anti-ban work',
		h1: 'Does GB WhatsApp Anti-Ban Really Work?',
		lead:
			'“Anti-ban” is wording from the mod, not from WhatsApp. It may change a privacy toggle. It cannot promise your number will stay unrestricted.',
		body: `
      <h2>What the label usually means</h2>
      <p>In GB WhatsApp Pro settings, anti-ban often points at options that hide read receipts, freeze last seen, or delay online status. Those are client-side switches. WhatsApp’s servers can still see that the app is not the official client.</p>
      <p>A download page that says “100% ban proof” or “approved by WhatsApp” is contradicting WhatsApp’s own help text. Treat that page as marketing, not as a safety test.</p>

      <h2>What it cannot do</h2>
      <p>It cannot turn this APK into the Play Store app. It cannot erase a warning that already appeared on your number. Installing a newer build with a different anti-ban badge does not reset enforcement history.</p>
      <p>If you want the plain risk, read <a href="/will-gb-whatsapp-get-you-banned/">why an unofficial client can still be limited</a>. The short version: quiet personal use is lower risk than bulk sending, and neither is guaranteed.</p>

      <h2>If a warning shows up anyway</h2>
      <p>Turn the feature off in your head as a guarantee and follow the banner. <a href="/gb-whatsapp-says-use-official-whatsapp/">When the screen tells you to use official WhatsApp</a>, another anti-ban APK is the wrong next step. Export what you can, then decide whether this number should leave the mod.</p>
      <p>Privacy toggles also do not audit the file you installed. Hiding blue ticks does not tell you what the APK can read on the phone.</p>
    `,
		faqs: [
			[
				'Is the newest anti-ban APK the safe one?',
				'Newer is not the same as official. Check the file source and your own sending habits. The label is not a safety rating.',
			],
			[
				'Can anti-ban lift a ban that already happened?',
				'No. Follow the on-screen WhatsApp message. A mod setting cannot reverse it.',
			],
		],
		publishedAt: '2026-10-17',
		updatedAt: '2026-11-04',
		coverTheme: 'safe',
		coverLabel: 'Anti-Ban',
	},
}
